validatePartialDataReturn